module.exports = __webpack_public_path__ + "static/media/wR.57350123.svg";